import React from "react";

const Completed = () => {
  return (
    <div className="text-center">
      <h2 className="text-2xl font-semibold mb-4">Experiment Completed</h2>
      <p>You have successfully completed this experiment.</p>
    </div>
  );
};

export default Completed;